module.exports = __webpack_public_path__ + "./Danny_1767deb397765e48fd6adb7cef362306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Danny.jpg
// module id = 550
// module chunks = 0